import { render, staticRenderFns } from "./ConcejoView.vue?vue&type=template&id=0af9585c"
import script from "./ConcejoView.vue?vue&type=script&lang=ts"
export * from "./ConcejoView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports